import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../../models/RequirementStatusModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { Text } from '../../inputs/inputs';
import { formatDataBeforeDisplay, formatDataBeforeSend } from '../../../helpers/GeneralHelper';

export const StatusForm = ({module, showModal, setShowModal, refreshData, data, modalKey}) => {

  const inputFields = {
    status_name: '',
  }
  const formatOptions = [];

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate(); 

  const { state } = useAuth();
  let user_data = state.user_data;
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [id, setId] = useState('');
  const [fields, setFields] = useState(inputFields);

  const closeModal = () =>{
    setId('');
    setFields(inputFields);
    setErrors({});

    setShowModal(false);
  }

  useEffect(() => {
    // This effect will be called whenever data changes
    if (data) {
      setId(data[module.primaryCol]);
      setFields(formatDataBeforeDisplay(data, formatOptions));
      setErrors({});
    }
  }, [data, modalKey]);
  
  const submit = async(e) => {
    e.preventDefault();
    
    // Start the loading state
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
      let response;
      if (data) {
        response = await model.update(user_data.user_token, id, formData);
      } else {
        response = await model.create(user_data.user_token, formData);
      }

      if (response.status) {
        setNotificationCount(localStorage.getItem('unread_notification_count'));
        toast.success(response.message);
        closeModal();

        model.saveToStorage(response.data[module.key], response.data.pagination);
        refreshData();
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);

      if (error.response?.data.invalid_token == 1) {
        navigate('/re-login');
      }
    }

    // Stop the loading state
    setLoading(false);
  }

  return (
    <Modal className="cms-modal-form" show={showModal} onHide={closeModal} size='' backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>{modalKey == null ? 'Add' : 'Edit'} {module.singularTitle}</Modal.Title>
        </Modal.Header>

        <form onSubmit={submit}>
          <Modal.Body>
            <div className="row gy-2">
              <div className="col-xl-12">
                <Text column="status_name" label="Status" required={true} fields={fields} setFields={setFields} errors={errors} ></Text>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
              <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
              <button className="btn btn-primary" disabled={loading}>
                {loading ? <span><span className="spinner-border spinner-border-sm align-middle"></span> Loading...</span> : 'Submit'}
              </button>
          </Modal.Footer>
        </form>
    </Modal>
  );
};
